module.exports = __webpack_public_path__ + "images/category_lp/tablet/store_images/4_78f0ecd63fb95a16d2054b479ebb8ddd.png";